import { gql } from '@apollo/client';

export default gql`
  query spaceOrders($page: Int) {
    spaceOrders(page: $page) {
      spaceOrdersTotalPages
      spaceOrdersTotal
      perPage
      hasNextPage
      spaceOrders {
        id
        amount
        currency
        createdAt
        status
        plan {
          name
        }
      }
    }
  }
`;
